import { useState } from 'react';
import PropTypes from 'prop-types';
import Image from 'next/image';
import classNames from 'classnames';
import Text from '@hiredigital/ui/Text/Text';
import { Section } from '@components/Section';
import Img from '@components/Img';

import Styles from './OurCustomers.module.scss';

const OurCustomers = ({ list, className }) => {
  const [newList, setNewList] = useState();

  const showList = () => {
    const lx = [];
    list.map((brand, i) =>
      lx.push(
        <div className={Styles.container} key={i}>
          <Image className={Styles.img} src={brand} alt={brand} height={100} width={150} />
        </div>
      )
    );
    setNewList(lx);
  };

  if (list.length && !newList) {
    showList();
  }

  return (
    <Section title={'Our Customers'} className={classNames(Section.Styles.large, className)}>
      <div style={{ maxWidth: '900px' }}>
        <Text type={Text.Type.NORMAL}>
          {`Brands both large and small leverage Hire Digital's talent platform to flexibly and effectively scale their marketing efforts.`}
        </Text>
      </div>
      <br />
      <div className={Styles.customers}>{newList}</div>
    </Section>
  );
};

OurCustomers.propTypes = {
  list: PropTypes.array,
};

export default OurCustomers;
